var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Grupos","p-read-link":"groups.read.one","p-create-link":"groups.create","p-name":"groups"}})}
var staticRenderFns = []

export { render, staticRenderFns }